module.exports = __webpack_public_path__ + "img/goTop.527adcee.svg";